import { HalfSunRays } from "@/components/ui/HalfSunRays";
import { IconChevronDown } from "@/components/ui/IconChevronDown";
import { PrimaryContainerComponent } from "@/components/layouts/PrimaryContainerComponent";
import { SubFooter } from "@/components/layouts/SubFooter";
import { NavLink } from "react-router";

export default function PrivacyPolicy() {
    return (
        <div className="w-full px-4 py-12 md:py-20 md:max-w-7xl mx-auto md:px-16 lg:px-24">
            <header className="flex flex-col gap-4 border-b border-black-700 pb-12">
                <h2 className="text-6xl md:text-8xl font-token text-off-white">Privacy Policy</h2>
                <div className="flex flex-row gap-4 items-center">
                    <div className="rounded-full border border-black-400 px-4 py-2 uppercase font-mono font-semibold text-base text-black-400 leading-4">
                        V 1.0
                    </div>
                    <p className="font-mono text-lg text-black-400 leading-8">January 9, 2025</p>
                </div>
            </header>

            <main className="font-mono text-lg md:text-xl text-black-400 leading-8 md:leading-10 py-12 flex flex-col gap-16">
                <p>Welcome to <span className="font-bold text-teal">$THINK</span>'s Privacy Policy. This policy outlines how we collect, use, disclose, and safeguard your personal information when you access or use our services, websites, applications, and other offerings (collectively referred to as the "Services"). By accessing or using our Services, you consent to the collection, use, disclosure, and safeguarding of your personal information as described in this Privacy Policy. Please read this Privacy Policy carefully to understand our practices regarding your personal information.</p>

                <section>
                    <header className="mb-4">
                        <h3 className="text-off-white font-medium font-heading text-4xl">1. Information We Collect</h3>
                    </header>

                    <p>
                        <span className="font-semibold text-teal">1.1 </span>
                        Personal Information: We may collect personal information that you provide to us when you use our Services, such as your name, email address, postal address, phone number, and payment information.
                    </p>

                    <p>
                        <span className="font-semibold text-teal">1.2 </span>
                        Usage Information: We may also collect information about how you access and use our Services, including your IP address, device information, browser type, operating system, and usage data.
                    </p>
                </section>

                <section>
                    <header className="mb-4">
                        <h3 className="text-off-white font-medium font-heading text-4xl">2. How We Use Your Information</h3>
                    </header>
                    <p>
                        <span className="font-semibold text-teal">2.1 </span>
                        Provision of Services: We use your personal information to provide, maintain, and improve our Services, as well as to communicate with you about your account and our offerings.
                    </p>

                    <p>
                        <span className="font-semibold text-teal">2.2 </span>
                        Analytics and Personalization: We may use usage information to analyze trends, administer the Services, track users' movements around the Services, and gather demographic information about our user base. We may also use this information to personalize your experience with our Services.
                    </p>
                </section>

                <section>
                    <header className="mb-4">
                        <h3 className="text-off-white font-medium font-heading text-4xl">3. Information Sharing and Disclosure</h3>
                    </header>
                    <p>
                        <span className="font-semibold text-teal">3.1 </span>
                        Third-Party Service Providers: We may share your personal information with third-party service providers that help us operate our Services, such as hosting providers, payment processors, and analytics providers.
                    </p>
                    <p>
                        <span className="font-semibold text-teal">3.2 </span>
                        Legal Compliance: We may disclose your personal information if required to do so by law or in response to valid legal requests, such as subpoenas or court orders.
                    </p>
                </section>

                <section>
                    <header className="mb-4">
                        <h3 className="text-off-white font-medium font-heading text-4xl">4. Data Security</h3>
                    </header>
                    <p>
                        <span className="font-semibold text-teal">4.1 </span>
                        We take reasonable measures to protect your personal information from unauthorized access, use, disclosure, alteration, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your personal information.
                    </p>
                </section>

                <section>
                    <header className="mb-4">
                        <h3 className="text-off-white font-medium font-heading text-4xl">5. Your Choices</h3>
                    </header>
                    <p>
                        <span className="font-semibold text-teal">5.1 </span>
                        You may choose not to provide certain personal information, but this may limit your ability to access or use certain features of our Services.
                    </p>
                    <p>
                        <span className="font-semibold text-teal">5.2 </span>
                        You may opt out of receiving promotional communications from us by following the instructions provided in those communications or by contacting us directly.
                    </p>
                </section>

                <section>
                    <header className="mb-4">
                        <h3 className="text-off-white font-medium font-heading text-4xl">6. Changes to This Privacy Policy</h3>
                    </header>
                    <p>
                        <span className="font-semibold text-teal">6.1 </span>
                        We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                    </p>
                </section>

                <section>
                    <header className="mb-4">
                        <h3 className="text-off-white font-medium font-heading text-4xl">7. Contact Us</h3>
                    </header>
                    <p>
                        <span className="font-semibold text-teal">7.1 </span>
                        If you have any questions or concerns about this Privacy Policy or our practices regarding your personal information, please contact us here: <NavLink to="/contact" className="font-semibold text-teal">contact us</NavLink>.
                    </p>
                </section>

                <section>
                    <p>This Privacy Policy constitutes the entire agreement between you and <span className="font-semibold text-teal">$THINK</span> regarding the collection, use, disclosure, and safeguarding of your personal information and supersedes all prior or contemporaneous agreements, representations, warranties, and understandings, whether oral or written.</p>
                </section>
            </main>
        </div>

    );
}